import { DeviceType, Host, HostMap, Schedule } from 'services/pangolin/types';
import { hostDisplayDeviceType } from 'services/pangolin/hosts_service';

export type ALL_DEVICES = 9999;
export const ALL_DEVICES: ALL_DEVICES = 9999;
export type ALL_DEVICES_ID = 'ALL_DEVICES_ID';
export const ALL_DEVICES_ID: ALL_DEVICES_ID = 'ALL_DEVICES_ID';

export type AllDevicesDeviceEntry = {
  kind: ALL_DEVICES;
  host: {
    id: ALL_DEVICES_ID;
  };
};
export type HostDeviceEntry = { kind: DeviceType; host: Host };
export type DeviceEntry = AllDevicesDeviceEntry | HostDeviceEntry;

export const getDeviceEntryID = (entry: DeviceEntry): string => {
  return entry.host.id;
};

export const hostToDeviceEntry = (host: Host): DeviceEntry => {
  return {
    kind: hostDisplayDeviceType(host),
    host,
  };
};

export function createDeviceEntries(schedule: Schedule, hosts: HostMap): DeviceEntry[] {
  const entries: DeviceEntry[] = [];

  if (schedule.applyToAllHosts) {
    entries.push({
      kind: ALL_DEVICES,
      host: {
        id: 'ALL_DEVICES_ID',
      },
    });
  }

  schedule.hostIDs.forEach((host_id) => {
    const host = hosts.get(host_id);
    if (host) entries.push({
      kind: hostDisplayDeviceType(host),
      host,
    });
  });

  return entries;
}
